export const regulations = {
  hero: {
    title: 'PRAVILNIK TRKE',
    subtitle: 'Službena pravila i informacije za SINJAVINA SKYRACE 2026',
  },
  overview: {
    title: 'INFORMACIJE O TRCI',
    subtitle: 'Dvije trke, jedna početna tačka',
    race1: 'SINJAVINA SKYRACE: 40km sa 2000m D+',
    race2: 'SINJAVINA MINI SKYRACE: 10km sa 1000m D+',
    tableHeaders: {
      detail: 'Detalj',
      information: 'Informacija',
    },
    startLocation: 'Lokacija starta',
    startLocationValue: 'Motel Ravnjak, Selo Bistrica, Mojkovac',
    startCoordinates: 'Koordinate starta',
    miniFinish: 'Cilj Mini Skyrace',
    miniFinishValue: 'Zabojsko jezero (Eko koliba)',
    miniFinishCoords: 'Koordinate cilja Mini Skyrace',
    skyraceFinish: 'Cilj Skyrace',
    skyraceFinishValue: 'Gradski trg, Mojkovac',
    skyraceFinishCoords: 'Koordinate cilja Skyrace',
    miniMaxAlt: 'Mini maksimalna nadmorska visina',
    skyraceMaxAlt: 'Skyrace maksimalna nadmorska visina',
  },
  aidStations: {
    title: 'OKREPNE STANICE I VREMENSKE KAPIJE',
    miniTitle: 'SINJAVINA MINI SKYRACE',
    skyraceTitle: 'SINJAVINA SKYRACE',
    aidStation: 'Okrepna stanica dostupna',
    finish: 'CILJ',
    finalCutoff: 'KONAČNO VREMENSKO OGRANIČENJE',
  },
  schedule: {
    title: 'RASPORED VIKENDA TRKE',
    friday: 'PETAK, 5. JUNI 2026',
    saturday: 'SUBOTA, 6. JUNI 2026',
    bibCollection: 'Preuzimanje startnih paketa u Mojkovcu',
    locationTBA: '(Lokacija će biti naknadno određena)',
    busTransport: 'Autobus iz Mojkovca prema startu (Bistrica)',
    reservation: 'Rezervacija: +382 68/898-636 ili sinjavinaskyrace@gmail.com',
    bibAtStart: 'Preuzimanje startnih paketa na startu (Motel Ravnjak)',
    raceStart: 'START TRKE',
    finalCutoff: 'Konačno vremensko ograničenje za SINJAVINA SKYRACE',
  },
  registrationInfo: {
    title: 'INFORMACIJE O PRIJAVI',
    method: 'Registracija se vrši isključivo online putem Avaibook platforme',
    period: 'Period',
    skyrace: 'Skyrace',
    miniSkyrace: 'Mini Skyrace',
    early: 'Rana (Do 1. marta)',
    standard: 'Standardna (Do 30. aprila)',
    late: 'Kasna (Do 15. maja)',
    warning: 'Prijava se zatvara 15. maja 2026. Prijava na licu mjesta nije dostupna.',
  },
  refund: {
    title: 'POLITIKA REFUNDACIJE',
    point1: 'Refundacija startnina je moguća isključivo u slučaju otkazivanja događaja zbog nemara organizatora. U slučaju više sile, nema refundacije.',
    point2: 'Organizator zadržava pravo da promijeni vrijeme ili datum trke bez refundacije.',
    point3: 'Organizator može prekinuti trku u slučaju nepredviđenih okolnosti koje ugrožavaju bezbjednost učesnika, i u tom slučaju refundacija neće biti omogućena.',
  },
  cta: {
    question: 'Pitanja o pravilniku?',
    button: 'IDI NA PRIJAVU',
  },
};